import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react';

import { EmblaCarouselType } from 'embla-carousel';

type CarouselContextProps = PropsWithChildren<{
  carousel?: EmblaCarouselType;
  canScrollNext: boolean;
  canScrollPrev: boolean;
}>;

const CarouselContext = createContext<CarouselContextProps>({
  carousel: undefined,
  canScrollNext: true,
  canScrollPrev: false,
});

export const CarouselProvider: FC<CarouselContextProps> = props => {
  const { carousel, canScrollNext, canScrollPrev, children } = props;
  const carouselProviderValue = useMemo(
    () => ({
      carousel,
      canScrollNext,
      canScrollPrev,
    }),
    [carousel, canScrollNext, canScrollPrev],
  );

  return (
    <CarouselContext.Provider value={carouselProviderValue}>
      {children}
    </CarouselContext.Provider>
  );
};

export const useCarousel = (): CarouselContextProps => {
  return useContext(CarouselContext);
};
